'use client'

import { UsdxlContainer } from '@/features/usdxl/UsdxlContainer'

export function Usdxl() {
  return <UsdxlContainer />
}
